import { useApi, createApiHook } from "../utils/apiUtils";

const useSendTimer = () => {
  const { apiPatch } = useApi();
  const useApiState = createApiHook(null);
  const { error, startLoading, setResponse } = useApiState();

  const sendTimer = async ({ startTime, endTime, assignappId }) => {
    startLoading();

    const response = await apiPatch(`/assignapps/${assignappId}/save_time`, "Error al guardar el tiempo", {
      start_time: startTime,
      end_time: endTime,
    });

    setResponse(response);

    return !response?.error;
  };

  return { sendTimer, error };
};

export default useSendTimer;
